/**
 * Mamash Wishlist — localStorage toggle for .mamash-wishlist-btn elements
 * Key: mamash_wishlist_v1  (same as Hydrogen/React version)
 * Shape: [{ id, handle, title, price, currency, image }]
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'mamash_wishlist_v1';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function isInWishlist(productId) {
    return getWishlist().some(function (item) {
      return String(item.id) === String(productId);
    });
  }

  function addToWishlist(data) {
    var list = getWishlist();
    if (!list.some(function (item) { return String(item.id) === String(data.id); })) {
      list.push(data);
      saveWishlist(list);
    }
  }

  function removeFromWishlist(productId) {
    var list = getWishlist().filter(function (item) {
      return String(item.id) !== String(productId);
    });
    saveWishlist(list);
  }

  function updateBtnState(btn, inList) {
    var icon = btn.querySelector('.mamash-wishlist-icon, svg');
    var label = btn.querySelector('.mamash-wishlist-label');
    if (inList) {
      btn.setAttribute('aria-label', 'Remove from wishlist');
      btn.classList.add('mamash-wishlisted');
      if (icon) {
        icon.style.fill = 'currentColor';
        icon.classList.add('text-primary');
        icon.classList.remove('text-muted-foreground');
      }
      if (label) label.textContent = 'Saved to Wishlist';
    } else {
      btn.setAttribute('aria-label', 'Add to wishlist');
      btn.classList.remove('mamash-wishlisted');
      if (icon) {
        icon.style.fill = 'none';
        icon.classList.remove('text-primary');
        icon.classList.add('text-muted-foreground');
      }
      if (label) label.textContent = 'Save to Wishlist';
    }
  }

  function syncAllBtns() {
    document.querySelectorAll('.mamash-wishlist-btn').forEach(function (btn) {
      var id = btn.dataset.productId;
      if (id) updateBtnState(btn, isInWishlist(id));
    });
    updateWishlistCount();
  }

  function updateWishlistCount() {
    var count = getWishlist().length;
    document.querySelectorAll('.mamash-wishlist-count').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function initBtn(btn) {
    var id = btn.dataset.productId;
    if (!id) return;
    updateBtnState(btn, isInWishlist(id));
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var inList = isInWishlist(id);
      if (inList) {
        removeFromWishlist(id);
      } else {
        addToWishlist({
          id: id,
          handle: btn.dataset.productHandle || '',
          title: btn.dataset.productTitle || '',
          price: btn.dataset.productPrice || '',
          currency: btn.dataset.productCurrency || 'INR',
          image: btn.dataset.productImage || ''
        });
      }
      updateBtnState(btn, !inList);
      updateWishlistCount();
    });
  }

  function init() {
    document.querySelectorAll('.mamash-wishlist-btn').forEach(initBtn);
    updateWishlistCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose for dynamically added buttons
  window.MamashWishlist = {
    init: function () {
      document.querySelectorAll('.mamash-wishlist-btn:not([data-wl-init])').forEach(function (btn) {
        btn.setAttribute('data-wl-init', '1');
        initBtn(btn);
      });
    },
    syncAll: syncAllBtns,
    getList: getWishlist,
    clear: function () {
      saveWishlist([]);
      syncAllBtns();
    }
  };
})();
